import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import Header from '@dashboard/components/pages/QueryListPage/PageWrapper/Header';
import { createTableComponent } from '@dashboard/components/pages/QueryListPage/TableList/WpDataGrid';
import { type FUserFragment, useLightPlatformQuery, useUsersQuery } from '@dashboard/generated/wp/administrator';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { Paper, Stack, Typography } from '@mui/material';
import useQueryDataTableProps from '@wp-react/hooks/useQueryDataTableProps';

import { DateFormatter } from '@waypoint/react-formatters';

function PlatformLink({ id }: { id: string }) {
  const { data } = useLightPlatformQuery({ variables: { id } });
  const text = !data ? id : data.Platform.name;
  return <Link href={`/o/${id}`}>{text}</Link>;
}

const UsersTable = createTableComponent<FUserFragment>({
  emptyResults: <>No users found</>,
  columns: [
    {
      headerName: 'Email Address',
      renderCell: ({ row }) => <Typography>{row.emailAddress}</Typography>,
    },
    {
      headerName: 'Joined',
      renderCell: ({ row }) => <DateFormatter value={row.createdAt} />,
    },
    {
      headerName: 'Last Seen At',
      renderCell: ({ row }) => <DateFormatter value={row.lastSeenAt} />,
    },
    {
      headerName: 'Platforms',
      renderCell: ({ row }) => (
        <Stack>{row.platformIds.map((id) => (id ? <PlatformLink key={id} id={id} /> : null))}</Stack>
      ),
    },
  ],
});

export default function UsersList() {
  const currentPage = useCurrentPage();
  const { data } = useUsersQuery({ variables: { page: currentPage } });
  const { pagination } = useQueryDataTableProps(data?.Users);
  const nodes = data?.Users.nodes;

  return (
    <Paper>
      <Header pagination={pagination} title="Users" />
      <UsersTable nodes={nodes} />
    </Paper>
  );
}
